<template>
  <table-layout :showSearch="false" title="دوره ها">
    <template #buttons>
      <router-link :to="{ name: 'TrashCourse' }">
        <b-button pill variant="danger"> سطل زباله</b-button>
      </router-link>

      <router-link :to="{ name: 'CreateCourse' }" class="ml-2">
        <b-button pill variant="purple"> ساخت دوره</b-button>
      </router-link>

      <LanguageSelectBox @changeLanguage="getItems" module-name="course" class="mx-4"/>

    </template>

    <template #table>
      <course-items :items="courses"></course-items>
      <b-row class="pt-3 mt-3">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </b-row>
    </template>
  </table-layout>

</template>

<script>
import {mapGetters} from "vuex";
import TableLayout from '../../components/dashboard/TableLayout.vue';
import CourseItems from '../../components/dashboard/Course/courseItems.vue'
import Pagination from "../../components/dashboard/Pagination.vue";
import LanguageSelectBox from "../../components/dashboard/Language/LanguageSelectBox";


export default {
  name: "Course",
  components: {CourseItems, TableLayout, Pagination, LanguageSelectBox},
  computed: {
    ...mapGetters({
      courses: "Course/getCourses",
      paginationMeta: "Course/getPaginationMeta",
    }),
  },
  methods: {
    changePage(page) {
      this.$store.dispatch("Course/setDashboardCourses", page);
    },
    getItems() {
      this.$store.dispatch("Course/setDashboardCourses")
    }
  },
  mounted() {
    this.getItems()
  }
};
</script>